<template>
  <router-view/>
</template>

<style>
h1 {
  font-size: 56px;
}

h2 {
  font-size: 48px;
}

h3 {
  font-size: 32px;
}

h4 {
  font-size: 20px;
}

p {
  font-size: 18px;
}

.text-center {
  text-align: center;
}
</style>
